import mapboxgl from "mapbox-gl";
import { StationInfo } from "../types";

type FC = GeoJSON.FeatureCollection;

const registryKey = "__stationMarkers";

export function clearStationMarkers(map: mapboxgl.Map) {
    const arr = (map as any)[registryKey] as mapboxgl.Marker[] | undefined;
    if (arr) arr.forEach((m) => m.remove());
    (map as any)[registryKey] = [];
}

export function createStationMarkers(
    map: mapboxgl.Map,
    fc: FC,
    onSelect: (st: StationInfo) => void
) {
    const markers: mapboxgl.Marker[] = [];

    for (const f of fc.features) {
        const props: any = f.properties || {};
        const id = props?.id ?? props?.station_id ?? props?.stationId ?? null;
        const name = props?.name || "(sin título)";
        const description = props?.description || "";
        const thumbnail = getThumb(props);

        const geom = (f as any).geometry as GeoJSON.Point | undefined;
        if (!geom || geom.type !== "Point") continue;
        const [lng, lat] = geom.coordinates as [number, number];

        // --- CONTENEDOR EXTERIOR ---
        const outer = document.createElement("div");
        outer.style.width = "90px";
        outer.style.height = "90px";
        outer.style.borderRadius = "50%";
        outer.style.display = "flex";
        outer.style.alignItems = "center";
        outer.style.justifyContent = "center";
        outer.style.cursor = "pointer";
        outer.style.boxShadow = "0 10px 22px rgba(0,0,0,.35)";
        outer.style.background =
            "conic-gradient(#a3e635 0deg, rgba(0,0,0,.8) 160deg, #a3e635 320deg)";
        outer.style.transform = "translate(-50%, -50%)";

        // --- IMAGEN INTERIOR (ajuste: 2.5 px de borde) ---
        const inner = document.createElement("div");
        inner.style.width = "85px"; // 90 - (2.5 px × 2)
        inner.style.height = "85px";
        inner.style.borderRadius = "50%";
        inner.style.background = thumbnail
            ? `center/cover no-repeat url('${thumbnail}')`
            : "#16a34a";
        inner.style.boxSizing = "border-box";

        outer.appendChild(inner);

        outer.addEventListener("click", (e) => {
            e.stopPropagation();
            onSelect({ id, name, description, thumbnail, lng, lat });
        });

        const marker = new mapboxgl.Marker({ element: outer, anchor: "center" })
            .setLngLat([lng, lat])
            .addTo(map);

        markers.push(marker);
    }

    (map as any)[registryKey] = markers;
}

function getThumb(props: any): string | null {
    const t = props?.thumbnail;
    if (!t) return null;
    if (typeof t === "string") {
        const s = t.trim();
        if (s.startsWith("{") && s.endsWith("}")) {
            try {
                const obj = JSON.parse(s);
                if (obj && typeof obj.url === "string") return obj.url;
            } catch { }
        }
        if (/^https?:\/\//i.test(s)) return s;
        return null;
    }
    if (typeof t?.url === "string") return t.url;
    return null;
}